import React from 'react'
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

interface SortingChartProps {
  data: any
}

const COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#FF5733',
  '#36A2EB',
  '#FF6384',
  '#4BC0C0',
  '#FFCE56',
  '#E7E9ED',
  '#99A8B2',
  '#8A2BE2'
];

const SortingChart: React.FC<SortingChartProps> = (props) => {
  const dataChart = []
  const { data } = props

  // Find the maximum number of positions across all answers
  //@ts-ignore
  const maxPositions = Math.max(...Object.values(data).map((answerArr) => answerArr.length));
  for (let i = 0; i < maxPositions; i++) {
    const row = { name: i + 1 };

    // Loop through each answer and get the count at the current position (i)
    for (const [answerKey, answerArr] of Object.entries(data)) {
      //@ts-ignore
      if (i < answerArr.length) {
        row[answerKey] = parseInt(answerArr[i].count);
      } else {
        row[answerKey] = 0; // If the answer doesn't have a count at this position, set it to 0
      }
    }

    dataChart.push(row);
  }

  return dataChart.length > 0 && <ResponsiveContainer width='100%' height={300}>
    <BarChart
      width={500}
      height={300}
      data={dataChart}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <CartesianGrid strokeDasharray='3 3' />
      <XAxis dataKey='name' />
      <YAxis allowDecimals={false} />
      <Tooltip cursor={{ fill: 'transparent' }} />
      <Legend />
      {Object.keys(dataChart[0]).map((key, index) => {
        if (key !== 'name') {
          return <Bar maxBarSize={25} dataKey={key} fill={COLORS[index % COLORS.length]} background={false} />
        }
      })}
    </BarChart>
  </ResponsiveContainer>
}
export default SortingChart